import React from 'react';
import {MDXProvider} from '@mdx-js/react';

const components = {
  h1: (props) => (
    <h1 className="text-2xl font-bold mb-4" {...props}>
      {props.children}
    </h1>
  ),
  h2: (props) => (
    <h2 className="text-normal font-bold mb-4" {...props}>
      {props.children}
    </h2>
  ),
  h3: (props) => (
    <h3 className="text-sm font-bold mb-4" {...props}>
      {props.children}
    </h3>
  ),
  p: (props) => (
    <p className="ac-chapter-copy mb-8 font-light" {...props}>
      {props.children}
    </p>
  ),
  blockquote: (props) => (
    <p
      className="font-light italic text-gray-500 pl-4 border-l-4 border-gray-300"
      {...props}
    >
      {props.children}
    </p>
  ),
};

export const CustomMDXProvider = ({children}) => {
  return <MDXProvider components={components}>{children}</MDXProvider>;
};

export {components};
